module.exports = __webpack_public_path__ + "media/images/pepsi_digin_brunch_lv/shape-1-c996af69cc13cb0faa8760aaa2b40a2f.png";